import { infiniteQueryOptions } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants.ts";
import { getNotificationsByAccount } from "@/api/graphql/notifications/account/api.ts";
import { GetNotificationsByAccount } from "@/api/graphql/notifications/types.ts";
import { NotificationsMsSearchNotificationsRequestSortField } from "@/api/graphql/types/graphql.ts";
import { getNextPage } from "@/helpers/api/getNextPageParam/helper.ts";

export const createGetNotificationsByAccountQueryOptions = (
  request: GetNotificationsByAccount,
  queryFn: typeof getNotificationsByAccount = getNotificationsByAccount,
) =>
  infiniteQueryOptions({
    queryKey: [
      queries.GET_NOTIFICATIONS_BY_ACCOUNT,
      request.accountId,
      request.pageSize,
    ],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      queryFn({
        filters: { accountId: request.accountId },
        paging: {
          page: pageParam,
          size: request.pageSize,
        },
        sorts: {
          field: NotificationsMsSearchNotificationsRequestSortField.CreatedTs,
          ascending: false,
        },
      }),
    getNextPageParam: (lastPage) => getNextPage(lastPage.pagination),
    enabled: Boolean(request.accountId),
  });
